export const PREDEFINED_BLUEPRINT_TYPES = {
	'meeting-notes': true,
	decisions: true,
	'kb-how-to-article': true,
	'file-list': true,
	retrospective: true,
	requirements: true,
	'shared-links': true,
	'kb-troubleshooting-article': true,
	'task-report': true,
	jirareport: true,
};
